import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import ChangeEmailContainer from "../containers/ChangeEmailContainer";

const ChangeEmailPage = () => {
  return (
    <UnderMaintenanceOrChildren>
      <ChangeEmailContainer />
    </UnderMaintenanceOrChildren>
  );
};

export default ChangeEmailPage;
